import React, { FC, HTMLAttributes, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDispatchRequest, useQuery } from '@redux-requests/react';
import { Field, Form } from 'react-final-form';
import classNames from 'classnames';
import BasicModal from '../BasicModal/BasicModal';
import { saveDeveloperProfile, toggleAccountDetails } from 'modules/layout/store/actions';
import { RootState } from 'store/rootReducer';
import { Button, Heading, Note } from 'components/ui';
import { TextInputWrapper } from 'components/forms';
import { AccountConstants } from 'modules/layout/store/constants';
import { t } from 'utils';
import { SuccessMessage } from 'components';
// import { timerDuration } from 'constants/others';
import styles from './AccountDetailsModal.module.scss';

export interface IAccountDetailsModal extends HTMLAttributes<HTMLDivElement> {}

const AccountDetailsModal: FC<IAccountDetailsModal> = (props) => {
  const { className } = props;
  const dispatch = useDispatch();
  const dispatchRequest = useDispatchRequest();
  const { data } = useQuery({ type: AccountConstants.ACCOUNT });
  const open = useSelector((state: RootState) => state.layout.accountDetails);
  const rootClassName = classNames(styles.root, className);

  const handleCloseModal = useCallback(() => {
    dispatch(toggleAccountDetails(false));
  }, [dispatch]);

  const handleAccountSubmit = useCallback(
    async (values) => {
      const { error } = await dispatchRequest(saveDeveloperProfile(values));
      return error;
    },
    [dispatchRequest]
  );

  return (
    <BasicModal className={rootClassName} open={open} onClose={handleCloseModal}>
      <Heading className='mb-4' icon='user-ninja'>
        {t('account.details')}
      </Heading>
      <Form
        onSubmit={handleAccountSubmit}
        initialValues={{ ...data, phone: (data.phone || {}).phone }}
        render={({ handleSubmit, submitSucceeded }) => (
          <form onSubmit={handleSubmit}>
            <Field
              name='firstName'
              label='global.name'
              placeholder='global.name.placeholder'
              className='mb-3'
              component={TextInputWrapper}
            />
            <Field
              name='lastName'
              label='global.lastName'
              placeholder='global.lastName.placeholder'
              className='mb-3'
              component={TextInputWrapper}
            />
            <Field
              name='email'
              label='global.email'
              placeholder='global.email.placeholder'
              type='email'
              className='mb-3'
              component={TextInputWrapper}
              disabled
            />
            <Field
              name='phone'
              label='global.phone'
              placeholder='global.phone.placeholder'
              className='mb-1'
              type='tel'
              component={TextInputWrapper}
            />
            <Note className='mb-3'>{t('account.details.phone.hint')}</Note>
            <Field
              name='companyName'
              label='global.company'
              placeholder='global.company.placeholder'
              className='mb-3'
              component={TextInputWrapper}
            />
            <Field
              name='website'
              label='global.website'
              placeholder='global.website.placeholder'
              type='url'
              className='mb-1'
              component={TextInputWrapper}
            />
            <Note className='mb-2'>{t('account.details.website.hint')}</Note>
            <SuccessMessage className='mb-3' isSuccess={submitSucceeded}>
              {t('account.details.success.saved')}
            </SuccessMessage>
            {/* {submitSucceeded && (
              <div className='mb-2'>
                {t('modal.will.be.close.in')}
                &nbsp;
                <Timer initialSeconds={timerDuration} onTimerEnd={handleCloseModal} />s
              </div>
            )} */}
            <Button
              className='mr-2'
              onClick={handleCloseModal}
              type='button'
              variant='secondary'
              inline
              bold
            >
              {t('cancel')}
            </Button>
            <Button inline>{t('save')}</Button>
          </form>
        )}
      />
    </BasicModal>
  );
};

export default AccountDetailsModal;
